export const COUPONSTATUS = {
    1: '立即领取',
    2: '已领取',
    3: '已领光',
    4: '立即抢购',
    5: '已购买',
    6: '已抢光'
}